import React from 'react';
import { FormattedMessage } from 'react-intl';

import { formatDuration } from '../utils';
import { RecordDot, TimerUI } from './UI';
import usePausableTimer from '../hooks/usePausableTimer';

type RecordTimerProps = {
  isPaused?: boolean;
}

const RecordTimer: React.FC<RecordTimerProps> = ({ isPaused }) => {
  const elapsedMs = usePausableTimer(isPaused);

  return (
    <TimerUI data-cy="camera-recording-timer">
      {isPaused
        ? <FormattedMessage id="camera.paused" defaultMessage="Paused" />
        : <RecordDot />}
      {formatDuration(elapsedMs)}
    </TimerUI>
  );
};

export default RecordTimer;
